import { render, staticRenderFns } from "./phonePageQr.vue?vue&type=template&id=7a4fe24f&scoped=true"
import script from "./phonePageQr.vue?vue&type=script&lang=js"
export * from "./phonePageQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4fe24f",
  null
  
)

export default component.exports